import ClientPortalFeeSchedule from './ClientPortalFeeSchedule';

export default ClientPortalFeeSchedule;
